export const None = -1;
export const EntityCreated = 0;
export const EntityUpdated = 1;
export const EntityDeleted = 2;
